/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 付费视频更多
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  condition: cloundtheater.SearchCondition,

  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: cloundtheater.Page<cloundtheater.VideoDto>;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "post",
    url: `/cloundtheater/paid-video-all`,
    data: condition,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
